<section id="distributions" (window:resize)="findScreenSize()">
    <div id="distributions_section" *ngIf="distributionsModel?.profile.fundProfile?.isMutualFund || distributionsModel?.profile.fundProfile?.isETF">
        <div class="distribution-header-sec upper-section container">
          <div class="row">
            <div class="col-sm-12 distribution-header">
                <h2 class="rps-heading-two" id="distributions_header">Distributions</h2>
            </div>
          </div>
        </div>
        <div class="redBanner-row container">
          <div class="row">

            <div class="col-lg-4">
                <div class="rowAsOf">
                    <h5 class="rps-heading-five">Realized/Unrealized gains</h5>
                    <p class="caption rps-paragraph-two rps-grey" *ngIf="distributionsModel?.distributions.realizedUnrealizedGain?.asOfDate" data-rpa-tag-id="realizedUnrealizedDate">as of {{distributionsModel.distributions.realizedUnrealizedGain.asOfDate | ESTPipe}}
                    </p>
                </div>
                <div class="mid-section">
                    <div class="row">
                        <div class="col-6 col-sm-4 col-md-4 col-lg-6 gain-col">
                            <p class="gain-header rps-paragraph-two">Realized gain</p>
                          <h4 class="gain-value rps-heading-four" *ngIf="distributionsModel?.distributions.realizedUnrealizedGain?.realized; else realized_mdash" data-rpa-tag-id="realizedGain">{{distributionsModel.distributions.realizedUnrealizedGain.realized | currency:'USD':'symbol':'1.2-2'}}
                          </h4>
                          <ng-template #realized_mdash>
                            <h4 class="gain-value rps-heading-four" data-rpa-tag-id="realizedGain">&mdash;</h4>
                          </ng-template>
                        </div>
                        <div class="col-6 col-sm-4 col-md-4 col-lg-6 gain-col">
                          <p class="gain-header rps-paragraph-two">% of NAV</p>
                          <div class="price-data-wrap">
                            <c11n-icon
                              class="value-change-icon"
                              *ngIf="realizedPerofNAV"
                              [name]="realizedPerofNAV | valueChange : 'name'"
                              [size]="'small'"
                              [altText]="realizedPerofNAV | valueChange : 'altText'">
                            </c11n-icon>
                            <span class="vg-heading-four--regular" *ngIf="distributionsModel?.distributions.realizedUnrealizedGain?.realizedPctNAV; else realizedPctNAV_mdash"
                                  data-rpa-tag-id="realizedpercentNAV">{{distributionsModel.distributions.realizedUnrealizedGain.realizedPctNAV}}%
                            </span>
                          </div>
                          <ng-template #realizedPctNAV_mdash>
                            <h4 class="gain-value rps-heading-four" data-rpa-tag-id="realizedpercentNAV">&mdash;</h4>
                          </ng-template>
                        </div>
                        <div class="col-6 col-sm-4 col-md-4 col-lg-6 gain-col">
                            <p class="gain-header rps-paragraph-two">Unrealized gains of NAV</p>
                          <h4 class="gain-value rps-heading-four" *ngIf="distributionsModel?.distributions.realizedUnrealizedGain?.unRealized; else unRealized_mdash" data-rpa-tag-id="unrealizedGain">{{distributionsModel.distributions.realizedUnrealizedGain.unRealized | currency:'USD':'symbol':'1.2-2'}}
                          </h4>
                          <ng-template #unRealized_mdash>
                            <h4 class="gain-value rps-heading-four" data-rpa-tag-id="unrealizedGain">&mdash;</h4>
                          </ng-template>
                        </div>
                        <div class="col-6 col-sm-4 col-md-4 col-lg-6 gain-col">
                          <p class="gain-header rps-paragraph-two">% of NAV</p>
                          <div class="price-data-wrap">
                            <c11n-icon
                              class="value-change-icon"
                              *ngIf="unrealizedPerofNAV"
                              [name]="unrealizedPerofNAV | valueChange : 'name'"
                              [size]="'small'"
                              [altText]="unrealizedPerofNAV | valueChange : 'altText'">
                            </c11n-icon>
                            <span class="vg-heading-four--regular" *ngIf="distributionsModel?.distributions.realizedUnrealizedGain?.unRealizedPctNAV; else unRealizedPctNAV_mdash"
                                  data-rpa-tag-id="unrealizedPercentNAV">{{distributionsModel.distributions.realizedUnrealizedGain.unRealizedPctNAV}}%
                            </span>
                          </div>
                          <ng-template #unRealizedPctNAV_mdash>
                            <h4 class="gain-value rps-heading-four" data-rpa-tag-id="unrealizedPercentNAV">&mdash;</h4>
                          </ng-template>
                        </div>
                        <div class="col-6 col-sm-4 col-md-4 col-lg-6 gain-col">
                            <p class="gain-header rps-paragraph-two">Fiscal year end</p>
                            <h4 class="gain-value rps-heading-four" data-rpa-tag-id="fiscalYearEnd">{{distributionsModel?.distributions.realizedUnrealizedGain?.fiscalYearEnd ? (distributionsModel.distributions.realizedUnrealizedGain.fiscalYearEnd | ESTPipe) : '&mdash;'}}
                            </h4>
                        </div>
                        <div class="col-6 col-sm-4 col-md-4 col-lg-6 gain-col">
                            <p class="gain-header rps-paragraph-two">Distribution schedule</p>
                            <h4 class="gain-value rps-heading-four
                            " data-rpa-tag-id="distributionSchedule">{{distributionsModel?.distributions.divCapGain?.distributionFrequency ? distributionsModel.distributions.divCapGain.distributionFrequency : '&mdash;'}}
                            </h4>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-none d-lg-block col-lg-8 redBanner">
                <div class="col-sm-9 text-container-position">
                    <p class="bannerText rps-paragraph-two rps-white" [innerHTML]="fundsCapitalBanner?.contentValue"></p>
                    <p class="bannerTextItalic rps-paragraph-two rps-white" [innerHTML]="fundsCapitalBanner2?.contentValue"></p>
                    <a class="bannerLink" role="button" tabindex="0" href="javascript:void(0)" (click)= "setDialogInfo('More about realized & unrealized gains & losses'); distributionComponentModal.openModalDialog($event);">Learn about realized and unrealized gains and losses</a>
                </div>
            </div>

          </div>
        </div>

      <div class="d-lg-none redBanner container-fluid">
        <div class="text-container-position container">
          <div class="row">
            <p class="col-12 bannerText rps-paragraph-two rps-white" [innerHTML]="fundsCapitalBanner?.contentValue"></p>
            <p class="col-12 bannerTextItalic rps-paragraph-two rps-white" [innerHTML]="fundsCapitalBanner2?.contentValue"></p>
            <a class="col-12 bannerLink" role="button" tabindex="0" href="javascript:void(0)" (click)= "setDialogInfo('More about realized & unrealized gains & losses'); distributionComponentModal.openModalDialog($event);">Learn about realized and unrealized gains and losses</a>
          </div>
        </div>
      </div>

      <c11n-modal-dialog
        modalId="distributionComponentModal"
        [headingText]="dialogTitle"
        #distributionComponentModal
      >
        <div c11n-modal-dialog-body>
          <div *ngIf="showRealizeDialogContent">
            <ng-container *ngTemplateOutlet="realiazeDialogContent"></ng-container>
          </div>
          <div *ngIf="!showRealizeDialogContent">
            <ng-container *ngTemplateOutlet="distributionComponentDialog"></ng-container>
          </div>
        </div>
      </c11n-modal-dialog>

        <div class="inner-section container">
            <div class="row dividend-heading" [ngStyle]="{'margin-bottom':(innerWidth>=1024  && innerWidth<1440) ? '7px' : '1.8125em' }">
                <div class="col-sm-12">
                    <h5 class="rps-heading-five">Dividend income and capital gains</h5>
                </div>
            </div>
            <div id="relative-parent-for-scroll-buttons">
                <div class="row">
                    <div class="horizontal-scroll-table">
                        <table class="table table-hover" *ngIf="!noDistributionTableData">
                            <thead>
                                <tr>
                                    <th scope="col" style="text-align: left;">Type</th>
                                    <th scope="col" style="text-align: right;">$/Share</th>
                                    <th scope="col" style="text-align: right;">
                                        <a role="button" tabindex="0" class="secYieldLink dialog-button" (click)="setDialogInfo('Payable date'); distributionComponentModal.openModalDialog($event);" href="javascript:void(0)">
                                    Payable date
                                </a>
                                    </th>
                                    <th scope="col" style="text-align: right;">
                                        <a role="button" tabindex="0" class="secYieldLink dialog-button" (click)="setDialogInfo('Record date'); distributionComponentModal.openModalDialog($event);" href="javascript:void(0)">
                                    Record date
                                </a>
                                    </th>
                                    <th *ngIf="distributionsModel?.profile.fundProfile?.isETF" scope="col" style="text-align: right;">
                                        <a role="button" tabindex="0" class="secYieldLink dialog-button" (click)="setDialogInfo('Ex-dividend date'); distributionComponentModal.openModalDialog($event);" href="javascript:void(0)">
                                    Ex-dividend date
                                </a>
                                    </th>
                                    <th *ngIf="distributionsModel?.profile.fundProfile?.isMutualFund" scope="col" style="text-align: right;">
                                        <a role="button" tabindex="0" class="secYieldLink dialog-button" (click)="setDialogInfo('Reinvest date'); distributionComponentModal.openModalDialog($event);" href="javascript:void(0)">
                                    Reinvest date
                                </a>
                                    </th>
                                    <th *ngIf="distributionsModel?.profile.fundProfile?.isMutualFund" scope="col" style="text-align: right;">Reinvest price</th>
                                    <th *ngIf="showDistributionYield && !hideDistributionYeild" scope="col" style="text-align: right;">
                                        <a role="button" tabindex="0" class="secYieldLink dialog-button" (click)="setDialogInfo('Distribution yield'); distributionComponentModal.openModalDialog($event);" href="javascript:void(0)">
                                    Distribution yield
                                </a>
                                    </th>
                                       <button class="right-btn" aria-label="Scroll Right" (click)="moveRight()" *ngIf="showRightButton && innerWidth<=576">
                                        &RightAngleBracket;
                                    </button>
                                    <button class="left-btn" aria-label="Scroll Left" (click)="moveLeft()" *ngIf="scrollBarPosition>0 && innerWidth<=576">
                                      &LeftAngleBracket;
                                  </button>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of currentItems | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize">
                                    <td style="text-align: left;" data-rpa-tag-id="type">{{item?.type ? item.type : '&mdash;'}}</td>
                                    <td style="text-align: right;" data-rpa-tag-id="dollarShare">{{item?.perShareAmount ? item.perShareAmount : '&mdash;'}}</td>
                                    <td style="text-align: right;" data-rpa-tag-id="payableDate">{{item?.payableDate ? (item.payableDate | ESTPipe) : '&mdash;'}}</td>
                                    <td style="text-align: right;" data-rpa-tag-id="recordDate">{{item?.recordDate ? (item.recordDate | ESTPipe) : '&mdash;'}}</td>
                                    <td style="text-align: right;" data-rpa-tag-id="reinvestDate">{{item?.reinvestmentDate ? (item.reinvestmentDate | ESTPipe) : '&mdash;'}}</td>
                                    <td *ngIf="distributionsModel?.profile.fundProfile?.isMutualFund" style="text-align: right;" data-rpa-tag-id="reinvestPrice">{{item?.reinvestPrice ? '$'+item.reinvestPrice : '&mdash;'}}</td>
                                    <td *ngIf="showDistributionYield && !hideDistributionYeild" style="text-align: right;" data-rpa-tag-id="distributionYield">{{item?.disributionYield ? item.disributionYield+'%' : '&mdash;'}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>


                </div>
                <div class="pagination-container" *ngIf="!noDistributionTableData;else noTableData">
                  <span aria-live="polite" aria-relevant="text" aria-atomic="true"  class="hide-text-screenreader-only" #distributionAriaLiveRegion></span>
                    <div class="dropdown-container">
                        <c11n-dropdown
                          (stateChange)="handleSelectionChange($event)"
                          [size]="dropdownSize"
                          [direction]="direction"
                          [hideLabel]="hideLabel"
                          [hintText]="hintText"
                          [variant]="variant"
                          [activeItems]="activeItems"
                          [selectedText]="selectedText"
                          [placeholderText]="placeholderText"
                          [menuData]="menuData">
                      </c11n-dropdown>
                    </div>
                </div>
            </div>
            <p *ngIf="hideDistributionYeild" class="weighted-exposures rps-paragraph-one rps-grey">Distribution yields are not available for products with less than 12 months of distribution history.</p>
            <ng-template #noTableData>
                <p class="no-data">This information is temporarily unavailable.</p>
            </ng-template>
        </div>
    </div>
  <ng-template #realiazeDialogContent>
    <div>
      <b>Understand the tax implications</b>
      <p class=" rps-paragraph-one" [innerHTML]="realizedUnrealizedGains?.contentValue">
      </p>

      <b>Realized gains & losses</b>
      <p class=" rps-paragraph-one" [innerHTML]="realizedGainsAndLosses?.contentValue">
      </p>
      <b>Unrealized gains & losses</b>
      <p class=" rps-paragraph-one" [innerHTML]="unRealizedGainsAndLosses?.contentValue"></p>
    </div>
  </ng-template>
  <ng-template #distributionComponentDialog>
    <div>
      <p class="rps-paragraph-one" [innerHTML]="dialogBody"></p>
    </div>
  </ng-template>
</section>
